'use client';

import { c as _c } from "react/compiler-runtime";
import { AppImage } from '@/app/components/media/app-image';
import { SpartanProductHeroBannerEngineLogoStretchPixel } from '@/app/lcv/components/sections/spartan/products/hero-banner/media/engine-logo-stretch-pixel';
import styles from '@/app/lcv/components/sections/spartan/products/hero-banner/media/parallax-scene/layout.module.css';
import type { SpartanProductHeroBannerEngineLogoProps } from '@/app/lcv/components/sections/spartan/products/hero-banner/specs/engine-logo/types';
import { SPARTAN_PRODUCT_HERO_BANNER_TRACKING } from '@/app/lcv/components/sections/spartan/products/hero-banner/tracking';
import { getSpartanProductHeroBannerEngineLogoLayoutStyle, getSpartanProductHeroBannerEngineLogoSizes } from '@/app/lcv/components/sections/spartan/products/hero-banner/utils/scene-layout';
import { cn } from '@/app/utils/cn';
export const SpartanProductHeroBannerEngineLogo = t0 => {
  const $ = _c(17);
  const {
    title,
    engineLogo
  } = t0;
  if (!engineLogo) {
    return null;
  }
  let t1;
  if ($[0] !== engineLogo.layout) {
    t1 = getSpartanProductHeroBannerEngineLogoSizes(engineLogo.layout);
    $[0] = engineLogo.layout;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const sizes = t1;
  const useStretchPixel = engineLogo.reveal === "stretch-pixel";
  let t2;
  if ($[2] !== engineLogo.className) {
    t2 = cn(styles.engineLogo, "relative max-w-full shrink-0", engineLogo.className);
    $[2] = engineLogo.className;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== engineLogo) {
    t3 = getSpartanProductHeroBannerEngineLogoLayoutStyle(engineLogo);
    $[4] = engineLogo;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== engineLogo.layout || $[7] !== engineLogo.revealStretchPixel || $[8] !== engineLogo.src || $[9] !== sizes || $[10] !== title || $[11] !== useStretchPixel) {
    t4 = useStretchPixel ? <SpartanProductHeroBannerEngineLogoStretchPixel src={engineLogo.src} alt={title} width={engineLogo.layout.lg.width} height={engineLogo.layout.lg.height} sizes={sizes} testId={SPARTAN_PRODUCT_HERO_BANNER_TRACKING.engineLogo} config={engineLogo.revealStretchPixel} /> : <AppImage src={engineLogo.src} alt={title} fill={true} sizes={sizes} objectFit="contain" fade={false} loading="eager" testId={SPARTAN_PRODUCT_HERO_BANNER_TRACKING.engineLogo} />;
    $[6] = engineLogo.layout;
    $[7] = engineLogo.revealStretchPixel;
    $[8] = engineLogo.src;
    $[9] = sizes;
    $[10] = title;
    $[11] = useStretchPixel;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== t2 || $[14] !== t3 || $[15] !== t4) {
    t5 = <div className={t2} style={t3}>{t4}</div>;
    $[13] = t2;
    $[14] = t3;
    $[15] = t4;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  return t5;
};